import produce from 'immer';

import * as helpers from './helpers';
import * as actions from './actions';

export const defaultState = {
    tables: [],
    socket: null,
    subscriptions: [],
    isNeedToStart: false,
    isSocketConnected: false,
    isSocketReconnected: false,
    dynamicImages: {
        timestamp: Date.now(),
        intervalId: null
    }
};

export const reducer = produce((draftState, action) => {
    switch (action.type) {
        case actions.LIVE_GAMES_IS_NEED_TO_START_UPDATE: {
            Object.assign(draftState, {
                isNeedToStart: action.payload
            });

            break;
        }

        case actions.LIVE_GAMES_RESET: {
            Object.assign(draftState, {
                tables: [],
                subscriptions: []
            });

            break;
        }

        case actions.LIVE_GAMES_SOCKET_SET: {
            Object.assign(draftState, {
                socket: action.payload
            });

            break;
        }

        case actions.LIVE_GAMES_CONNECTION_STATUS_UPDATE: {
            Object.assign(draftState, {
                isSocketConnected: action.payload
            });

            break;
        }

        case actions.LIVE_GAMES_RECONNECTION_STATUS_UPDATE: {
            Object.assign(draftState, {
                isSocketReconnected: action.payload
            });

            break;
        }

        case actions.LIVE_GAMES_SUBSCRIPTION_ADD: {
            draftState.subscriptions.push(action.payload);

            draftState.tables = helpers.mergeTables(draftState.tables, action.payload.tables);

            break;
        }

        case actions.LIVE_GAMES_SUBSCRIPTION_REMOVE: {
            draftState.subscriptions = draftState.subscriptions
                .filter((subscription) => !action.payload.includes(subscription.subscriptionId));

            draftState.tables = helpers.syncTablesWithSubscriptions(draftState.tables, draftState.subscriptions);

            break;
        }

        case actions.LIVE_GAMES_TABLES_ADD: {
            const { tables, subscriptionId } = action.payload;

            draftState.tables = helpers.mergeTables(draftState.tables, tables);

            const activeSubscription = draftState.subscriptions
                .find((subscription) => subscription.subscriptionId === subscriptionId);

            if (activeSubscription) {
                activeSubscription.tables = activeSubscription.tables.concat(tables);
            }

            break;
        }

        case actions.LIVE_GAMES_TABLES_UPDATE: {
            const { tables, subscriptionId } = action.payload;

            helpers.updateTables(draftState.tables, tables);

            const activeSubscription = draftState.subscriptions
                .find((subscription) => subscription.subscriptionId === subscriptionId);

            if (activeSubscription) {
                helpers.updateTables(activeSubscription.tables, tables);
            }

            break;
        }

        case actions.LIVE_GAMES_TABLES_REMOVE: {
            const { tables, subscriptionId } = action.payload;

            draftState.tables = helpers.removeTables(draftState.tables, tables, draftState.subscriptions);

            const activeSubscription = draftState.subscriptions
                .find((subscription) => subscription.subscriptionId === subscriptionId);

            if (activeSubscription) {
                activeSubscription.tables = helpers.removeTables(activeSubscription.tables, tables);
            }

            break;
        }

        case actions.LIVE_GAMES_IMAGES_TIMESTAMP_UPDATE: {
            draftState.dynamicImages.timestamp = action.payload;

            break;
        }

        case actions.LIVE_GAMES_IMAGES_INTERVAL_ID_UPDATE: {
            draftState.dynamicImages.intervalId = action.payload;

            break;
        }

        default: {
            break;
        }
    }
}, defaultState);
